import React, { useContext, useEffect, useState } from 'react'
import classNames from 'classnames'
import { Button } from '@toasttab/shared/src/components'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as LikeIcon } from '@toasttab/shared/src/assets/svg/feedback/like.svg'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as DisLikeIcon } from '@toasttab/shared/src/assets/svg/feedback/dislike.svg'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as CheckMarkIcon } from '@toasttab/shared/src/assets/svg/feedback/checkMark.svg'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as QuestionIcon } from '@toasttab/shared/src/assets/svg/feedback/question.svg'
import { OTLContext } from '@toasttab/shared/src/context/OTLContext'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'

interface ArticleFeedbackProps {
  slug: string
}

const ArticleFeedback = ({ slug }: ArticleFeedbackProps) => {
  const { t } = useI18next()
  const [submit, setSubmit] = useState(false)
  const otlParams = useContext(OTLContext)
  const OTLArticleUX: boolean = Boolean(otlParams.isArticle)

  useEffect(() => {
    const thisPageFeedback = localStorage.getItem(slug)
    if (thisPageFeedback) {
      setSubmit(true)
    }
  }, [])

  const sectionCss = classNames({
    'bg-otl-tan-dark border-2 border-otl-gray-light3 p-6 mt-16': !OTLArticleUX,
    'bg-white rounded-lg shadow-lg p-6 mt-16': OTLArticleUX
  })

  const buttonCss = classNames({
    'hover:bg-blue-0 hover:border-blue-100 hover:text-blue-100': true,
    'w-[136px]': OTLArticleUX
  })

  const handleYesClick = () => {
    localStorage.setItem(slug, 'Yes')
    setSubmit(true)
  }

  const handleNoClick = () => {
    localStorage.setItem(slug, 'No')
    setSubmit(true)
  }

  return (
    <section className={`${sectionCss}`}>
      <div className={`article-feedback__question ${submit ? 'hidden' : ''}`}>
        <div className={OTLArticleUX && 'flex'}>
          <QuestionIcon />
          <p
            className={`font-calibre font-semibold leading-none tracking-[-0.01em] mb-6 text-3xl ${
              OTLArticleUX && 'ml-4'
            } `}
          >
            {t('Is this article helpful?')}
          </p>
        </div>
        <div className='flex items-center'>
          <Button
            variation='secondary-outline-otl'
            size='medium'
            classes={`mr-[14px] ${buttonCss}`}
            onClick={handleYesClick}
          >
            <LikeIcon />
            <span className={OTLArticleUX && 'ml-2 font-semibold'}>Yes</span>
          </Button>
          <Button
            variation='secondary-outline-otl'
            size='medium'
            classes={buttonCss}
            onClick={handleNoClick}
          >
            <DisLikeIcon />
            <span className={OTLArticleUX && 'ml-2 font-semibold'}>No</span>
          </Button>
        </div>
      </div>
      <div className={`article-feedback__response ${submit ? '' : 'hidden'}`}>
        <CheckMarkIcon />
        <p className='font-calibre font-semibold leading-none tracking-[-0.01em] mb-6 text-3xl'>
          {t('Submitted! Thank you for your feedback.')}
        </p>
      </div>
    </section>
  )
}

export default ArticleFeedback
